import { Component, Input, Output, EventEmitter } from '@angular/core';
import { INgClass } from '@pmis3/ui-controls';

@Component({
    selector: 'kendo-checkbox',
    templateUrl: './kendo-checkbox.component.html',
})
export class KendoCheckboxComponent {
    @Input() value: boolean | undefined;
    @Input() label = '';

    @Input() disabled = false;
    @Input() indeterminate = false;

    @Input() inputClass: INgClass | undefined;
    @Input() labelClass: INgClass | undefined;
    @Input() title = '';
    @Input() tabIndex = 0;

    @Output() valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    uniqueId = Math.random();

    onValueChange() {
        this.valueChange.emit(this.value);
    }
}
